import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { CheckoutSuccessContext } from 'frontend/types/premium';

const checkoutSuccessContext: Module<CheckoutSuccessContext, RootState> = {
  namespaced: true,
  state: {} as CheckoutSuccessContext,
  getters: {},
  mutations: {
    setValue(state: CheckoutSuccessContext, value: CheckoutSuccessContext): void {
      Object.assign(state, value);
    },
  },
  actions: {},
};

export default checkoutSuccessContext;
